function formatNumber (n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}

export function formatTime (date) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  const t1 = [year, month, day].map(formatNumber).join('/')
  const t2 = [hour, minute, second].map(formatNumber).join(':')

  return `${t1} ${t2}`
}

// 获取当前周中周一和周末时间
function getWeekRange() {
  const now = new Date(); // 当前时间
  const dayOfWeek = now.getDay(); // 获取当前星期几（0-6，0为周日）
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // 距离周一的偏移
  const diffToSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek; // 距离周末的偏移

  // 获取周一和周日日期
  const monday = new Date(now);
  const sunday = new Date(now);
  monday.setDate(now.getDate() + diffToMonday); // 设置到周一
  sunday.setDate(now.getDate() + diffToSunday); // 设置到周末

  // 格式化输出
  const formatDate = (date) => {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };

  return {
      monday: formatDate(monday),
      sunday: formatDate(sunday),
  };
}

// 
function getMonthStartDates() {
  const now = new Date(); // 当前日期
  const currentYear = now.getFullYear(); // 当前年份
  const currentMonth = now.getMonth(); // 当前月份 (0-11)
  // 获取当月第一天
  const firstDayOfCurrentMonth = new Date(currentYear, currentMonth, 1);
  // 获取当前月份的天数
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  // 获取当前月份的最后一天
  const firstDayOfNextMonth = new Date(currentYear, currentMonth, daysInMonth);
  // 格式化输出
  const formatDate = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  };

  return {
    startDay: formatDate(firstDayOfCurrentMonth),
    endDay: formatDate(firstDayOfNextMonth),
  };
}

export default {
  formatNumber,
  formatTime,
  getWeekRange,
  formatTime,
  getMonthStartDates
}
